module.exports = __webpack_public_path__ + "img/hyperion.bc75307c.png";